import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';

import { CollapseComponent } from './collapse/collapse.component';
import queryString from 'query-string';
import { CookieService } from 'ngx-cookie-service';
import { LoaderComponent } from './loader/loader.component';
import { CreditIncreaseService } from './credit-increase.service';
import { ContentfulService } from './contentful.service';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterOutlet,
    CollapseComponent,
    LoaderComponent
],
})
export class AppComponent implements OnInit {
  title = 'increaseCreditLimit';
  params = queryString.parse(location.search);
  currentDate: any;
  footerlinks: any;
  copyRight: any;
  constructor(
    readonly cookieService: CookieService,
    readonly router: Router,
    readonly creditIncreaseService: CreditIncreaseService,
    readonly contentfulService: ContentfulService
  ) {
    let accountNumber: any = this.params['account_number'];
    this.cookieService.set('accountNumber', accountNumber, {
      path: '/',
      secure: true,
      sameSite: 'Lax',
    });
  }
  engLang = true;
  headerData: any;
  changeLang() {
    if (this.engLang === true) {
      this.engLang = false;
      this.creditIncreaseService.enLanguage.next(true);
    } else {
      this.engLang = true;
      this.creditIncreaseService.enLanguage.next(false);
    }
  }
  ngOnInit() {
    this.creditIncreaseService.enLanguage.subscribe((res: any) => {
      this.getContentfulData(res ? 'en' : 'fr');
    });
    this.router.navigate(['/'], { skipLocationChange: true });
    if (typeof globalThis !== 'undefined') {
      // browser code
      if (globalThis.location.href.split('/').filter(Boolean).includes('en')) {
        this.engLang = false;
        this.creditIncreaseService.enLanguage.next(true);

      }
      if (globalThis.location.href.split('/').filter(Boolean).includes('fr')) {
        this.engLang = true;
        this.creditIncreaseService.enLanguage.next(false);
      }
    }
    this.currentDate = new Date();
  }

  getContentfulData(currentLang: any) {
    this.contentfulService
      .getEntry(currentLang, 'footer', {
        include: 10,
      })
      .then((footer_res: any) => {
        let footer: any = footer_res;
        this.footerlinks = footer.links.fields.links;
        const year = footer?.copyrightText;
        this.copyRight = year.replace('##YEAR##', new Date().getFullYear());
      });

    this.contentfulService
      .getEntry(currentLang, 'header', {
        include: 10,
      })
      .then((header_res: any) => {
        this.headerData = header_res;
      });
  }
}
